import React from 'react';
import PropTypes from 'prop-types';
import * as styles from '../views.scss';

const FailedToLoad = ({ debugInfo }) => (
  <div className={styles.pageContent}>
    <h2>Failed to Load</h2>
    <div>Unfortunately the page failed to load. Please try again later.</div>
    {debugInfo ? (
      <div>
        <h4>Debug Info</h4>
        <div>{debugInfo}</div>
      </div>
    ) : (
      ''
    )}
  </div>
);

FailedToLoad.propTypes = {
  debugInfo: PropTypes.node
};

export default FailedToLoad;
